import { Injectable } from '@angular/core';
import {  NavigationStart, Router } from '@angular/router';
import { PopupControl } from 'src/app/models/popup-control.model';
import { NotificationService } from 'src/app/services/notification.service';

@Injectable({
  providedIn: 'root'
})
export class PageOptionsPopUpService {

	public popupControl: PopupControl = new PopupControl(
		{
			title: 'Page Options',

			width: '80%',
			height: '80%'
		}
	);

	public reset(): void {
		this.popupControl.options.title = 'Page Options';
		this.popupControl.description = null;

		
	}

  constructor(
		private _router: Router,
		private _notificationService: NotificationService,
	) {
		this._router.events.subscribe(
			(event: any) => {
				if (event instanceof NavigationStart) {
					this.reset();
				}
			}
		);
	}
}
